var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcoTick(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 10,
    viewBox: "0 0 11 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.03301 5C9.03301 7.20603 7.23787 9 5.0165 9C2.79514 9 1 7.20603 1 5C1 2.79397 2.79514 1 5.0165 1C7.23787 1 9.03301 2.79397 9.03301 5Z",
    fill: "currentColor",
    stroke: "currentColor",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.15708 3.1366L7.69472 3.67247L4.6283 6.7288L4.36117 6.98347L4.09404 6.7288L2.64551 5.28503L3.18315 4.74916L4.36117 5.9233L7.15708 3.1366Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoTick);
export default __webpack_public_path__ + "static/media/ico-tick.e8d739cf1d512f100c1ef45f53cde9f8.svg";
export { ForwardRef as ReactComponent };